import styled from "styled-components";

export const InputBox = styled.input`
    border: none;
    box-shadow: none;
    outline: none;
    background-color: inherit;
    color: inherit;
    width: 100%;
    &:focus {
      border: none;
    }
`
